<template>
  <b-sidebar
    id="filter-nav-sidebar"
    class="ml-3"
    right
    shadow
    :visible="sidebarVisible"
    @hidden="closeSidebar"
  >
    <template #header="{ hide }">
      <div class="d-flex align-items-center justify-content-between p-3">
        <h5 class="mb-0">Filter Services</h5>
        <button
          class="btn btn-link p-0"
          @click="hide"
          aria-label="Close filter menu"
        >
          <XIcon class="md-heroicon" />
        </button>
      </div>
    </template>

    <div class="p-3">
      <!-- Basic Filters -->
      <div class="mb-4">
        <h6 class="mb-3">Search Filters</h6>
        <SearchGroupMobile
          :params="currentFilterParams"
        />
      </div>

      <!-- Advanced Filters -->
      <div class="mb-4">
        <h6 class="mb-3">Refine Results</h6>
        <SearchFiltersMobile
          ref="searchFiltersMobile"
          :route-query="advancedFiltersFromRoute"
          @filter="handleAdvancedFilters"
          @clear="applyFilters"
        />
      </div>

      <!-- Apply Button -->
      <div class="d-flex justify-content-end mt-4">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          @click="clearFilters"
        >
          Clear
        </b-button>
        <b-button
          variant="primary"
          @click="applyFilters"
        >
          Apply Filters
        </b-button>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { XIcon } from '@vue-hero-icons/outline'
import SearchGroupMobile from '@/modules/results/components/Search/SearchGroupMobile'
import SearchFiltersMobile from '@/modules/results/components/SearchFiltersMobile'

export default {
  name: 'FilterSidebar',

  components: {
    XIcon,
    SearchGroupMobile,
    SearchFiltersMobile
  },

  data() {
    return {
      advancedFilters: {}
    }
  },

  computed: {
    sidebarVisible() {
      return this.$root.$filterSidebar?.filterSidebarVisible || false
    },

    currentFilterParams() {
      return this.$root.$filterSidebar?.filterParams || {}
    },

    advancedFiltersFromRoute() {
      const q = this.$route?.query || {}
      const basicKeys = ['postcode', 'service_type_id', 'date', 'search', 'page', 'order', 'order_by', 'favourites']
      const advanced = {}
      Object.keys(q).forEach(key => {
        if (!basicKeys.includes(key)) {
          advanced[key] = q[key]
        }
      })
      return advanced
    }
  },

  methods: {
    handleAdvancedFilters(filters) {
      this.advancedFilters = filters
    },

    applyFilters() {
      if (this.$root.$filterSidebar) {
        this.$root.$filterSidebar.applyFilters(this.advancedFilters)
      }
    },

    clearFilters() {
      this.$refs.searchFiltersMobile?.clearFilters()
      this.advancedFilters = {}
      if (this.$root.$filterSidebar) {
        this.$root.$filterSidebar.clearFilters()
      }
    },

    closeSidebar() {
      if (this.$root.$filterSidebar) {
        this.$root.$filterSidebar.closeFilterSidebar()
      }
    }
  }
}
</script>

